import React from 'react';
import { Pie } from '@ant-design/plots';

const BeneficiariesPieChart = ({ data }) => {
    const config = {
        appendPadding: 10,
        data: data.map((el) => ({ type: el.type, value: el?.count })),
        angleField: 'value',
        colorField: 'type',
        radius: 0.9,
        label: false,
        interactions: [{ type: 'element-active' }],
        tooltip: {
            fields: ['type', 'value'],
            formatter: (datum) => ({
                name: String(datum.type || 'Unknown'),
                value: String(datum.value ?? 'N/A'),
            }),
        },
        statistic: {
            title: {
                content: 'Themes',
            },
            content: false,
        },
        legend: {
            layout: 'vertical',
            position: 'right',
            maxRow: 20,
            itemSpacing: 1,
            itemName: {
                style: {
                    fontSize: 12,
                    lineHeight: 4,
                },
            },
            flipPage: false,
        },
        height: 400,
    };

    return (
        <div
            style={{
                width: '80vw',
                height: '400px',
                overflow: 'visible'
            }}
        >
            <style>
                {`
          .g2-legend {
            overflow: visible !important;
            max-height: none !important;
          }
          .g2-legend-list {
            display: flex !important;
            flex-direction: column !important;
            flex-wrap: nowrap !important;
            padding-right: 8px;
          }
          .g2-legend-paginator {
            display: none !important;
          }
        `}
            </style>
            <Pie {...config} />
        </div>
    );
};

export default BeneficiariesPieChart;